import { resolveInputFontSize } from '../TextInputStyles';
import { styledNodeAdornment } from './StyledNodeAdornment';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { clsx } from 'clsx';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const textStartAdornmentStyle = (theme, size, disabled) => ({
  fontSize: resolveInputFontSize(theme, size),
  fontFamily: theme.tokens.ComponentTextInputAdornmentFontFamily,
  fontWeight: theme.tokens.ComponentTextInputAdornmentFontWeight,
  lineHeight: theme.tokens.ComponentTextInputAdornmentLineHeight,
  color: disabled ? theme.tokens.ComponentTextInputDisabledColor : theme.tokens.ComponentTextInputAdornmentColor,
  backgroundColor: disabled ? theme.tokens.ComponentTextInputDisabledBgColor : theme.tokens.ComponentTextInputAdornmentBg
});

// eslint-disable-next-line react/no-multi-comp
export const StyledStartAdornment = _ref => {
  let {
    adornment,
    size,
    disabled,
    adornmentType
  } = _ref;
  const theme = useInterstateTheme();
  if (!adornment) {
    return null;
  }
  if (typeof adornment === 'string') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Box, {
        sx: textStartAdornmentStyle(theme, size, Boolean(disabled)),
        className: clsx([`ids-text-input-adornment-type-${adornmentType}`]),
        id: 'ids-text-input-adornment-start',
        children: adornment
      })
    });
  }
  return /*#__PURE__*/_jsx(Box, {
    sx: styledNodeAdornment({
      size,
      theme,
      adornmentType,
      disabled
    }),
    className: clsx([`ids-text-input-adornment-type-${adornmentType}`]),
    children: adornment
  });
};